//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  includeExpired: false,
  sortBy: 'dateCreated',
  queryKey: ['dpses'],
  queryOptions: {},
};

const getAll = async (queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const { data } = await axios.get(`/api/dps?${queryString}`);

  return data;
};

export const useGetAll = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, search, includeInactive, includeExpired, sortBy } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    includexpired: includeExpired,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery([...queryKey], () => getAll(queryStringParams), {
    select: ({ data: dpses, total }) => ({ dpses, total }),
    initialData: {
      dpses: [],
      total: 0,
    },
    ...queryOptions,
  });
};
